// extracted by mini-css-extract-plugin
export default {"root":"styles_root__niD3g","searchContainer":"styles_searchContainer__-4LkF","search":"styles_search__-Qwmq","products":"styles_products__a-YB7"};